import { Typography } from "antd";
import { CopyBlock, dracula } from 'react-code-blocks';
const { Paragraph, Text } = Typography;

export default function CodeBlock() {
    return (
        <div style={{top:"300px",position:"relative", padding: "40px", textAlign: "right", direction: "rtl" }}>
            <Paragraph>سیستمی همانند <span style={{ fontWeight: "bold", color: "#ff00a6" }}>پایا</span> را تجسم کنید.</Paragraph>
            <Paragraph>در این سیستم کاربر می‌تواند با استفاده از یک دستور در <span style={{ fontWeight: "bold", color: "#ff00a6" }}>ورودی</span>، درخواست <span style={{ fontWeight: "bold", color: "#ff00a6" }}>انتقال وجه</span> بدهد.</Paragraph>
            <Paragraph> بعد از ثبت انتقال وجه، مبلغ باید از حساب کاربر کم شده و در نزد بانک <span style={{ fontWeight: "bold", color: "#ff00a6" }}>رزرو</span> شود.</Paragraph>
            <Paragraph> در این مرحله یک تراکنش <span style={{ fontWeight: "bold", color: "#ff00a6" }}>کسر وجه</span> در حساب کاربر ثبت خواهد شد. (<span style={{ fontWeight: "bold" }}>شماره شبا با آی‌آر شروع شود و تعدادش ۲۴ رقم باشد</span>).</Paragraph>
            <div style={{ textAlign: "left", direction: 'ltr', paddingTop: "20px" }}>
                <CopyBlock
                    text={`### Send Shaba Request
 
POST http://localhost:80/api/sheba
Accept: application/json
 
{
    "price": 200000000,
    "fromShebaNumber": "IRxxxxxxxxxxxxxxxxxxxxx",
    "ToShebaNumber": "IRxxxxxxxxxxxxxxxxxxxxx",
    "note": "توضیحات تراکنش"
}`}
                    language="js"
                    showLineNumbers={true}
                    wrapLines
                    theme={dracula}
                />
            </div>
            <div style={{ textAlign: "left", direction: 'ltr', paddingTop: "20px" }}>
                <CopyBlock
                    text={`### Error Response
 
{
    "message": "Error Message",
    "code": "ErrorCode",
}`}
                    language="js"
                    showLineNumbers={true}
                    wrapLines
                    theme={dracula}
                />
            </div>
            <div style={{ textAlign: "left", direction: 'ltr', paddingTop: "20px",paddingBottom:"20px" }}>
                <CopyBlock
                    text={`### Success Response
 
{
    "message": "Request is saved successfully and is in pending status",
    "request": {
        "id": "request-id",
        "price": 200000000,
        "status": "pending",
        "fromShebaNumber": "IRxxxxxxxxxxxxxxxxxxxxx",
        "ToShebaNumber": "IRxxxxxxxxxxxxxxxxxxxxx",
        "createdAt": "2024-02-10T12:30-02:00"
    }
}`}
                    language="js"
                    showLineNumbers={true}
                    wrapLines
                    theme={dracula}
                />
            </div>
            <Paragraph>درخواست کاربر  برای بررسی در یک لیست مرتب قرار می‌گیرد.</Paragraph>
            <Paragraph> اپراتور بررسی با فراخوانی یک api می‌تواند لیست درخواست‌ها را مشاهده کند و پس از بررسی آدرس مبدا و مقصد و مبلغ تراکنش، با فراخوانی یک api دیگر زیر درخواست پرداخت تایید یا رد می‌شود.</Paragraph>
            <Paragraph> با رد شدن درخواست، پول باید به حساب کاربر بازگردد. در این مرحله یک تراکنش بازگشت پول ثبت خواهد شد و انتقال متوقف خواهد شد.</Paragraph>
            <div style={{ textAlign: "left", direction: 'ltr', paddingTop: "20px" }}>
                <CopyBlock
                    text={`### Confirm or Cancel Sheba Request
 
PUT/POST http://localhost:80/api/sheba/{{request-id}}
Accept: application/json
Content-Type: application/json
 
{
    "status": "confirmed", // Or canceled
    "note": "توضیحات تراکنش" // In Cancellation Scenario
}`}
                    language="js"
                    showLineNumbers={true}
                    wrapLines
                    theme={dracula}
                />
            </div>
            <div style={{ textAlign: "left", direction: 'ltr', paddingTop: "20px" }}>
                <CopyBlock
                    text={`### Error Response
 
{
    "message": "Error Message",
    "code": "ErrorCode"
}`}
                    language="js"
                    showLineNumbers={true}
                    wrapLines
                    theme={dracula}
                />
            </div>
            <div style={{ textAlign: "left", direction: 'ltr', paddingTop: "20px" }}>
                <CopyBlock
                    text={`#### Success Response
 
{
    "message": "Request is Confirmed!", // Or Canceled
    "request": {
        "id": "request-id",
        "price": 200000000,
        "status": "confirmed", // Or canceled
	    "fromShebaNumber": "IRxxxxxxxxxxxxxxxxxxxxx",
        "ToShebaNumber": "IRxxxxxxxxxxxxxxxxxxxxx",
	    "createdAt": "2024-02-10T12:30-02:00"
    }
}`}
                    language="js"
                    showLineNumbers={true}
                    wrapLines
                    theme={dracula}
                />
            </div>
            <div style={{ textAlign: "left", direction: 'ltr', paddingTop: "20px" }}>
                <CopyBlock
                    text={`### Requests List
 
GET http://localhost:80/api/sheba
Accept: application/json
 
### Success Response
{
    "requests": [
        {
       	 "id": "request-id",
            "price": 200000000,
            "status": "confirmed", // Or canceled
   	     "fromShebaNumber": "IRxxxxxxxxxxxxxxxxxxxxx",
            "ToShebaNumber": "IRxxxxxxxxxxxxxxxxxxxxx",
            "createdAt": "2024-02-10T12:30-02:00"
        }
    ]
}`}
                    language="js"
                    showLineNumbers={true}
                    wrapLines
                    theme={dracula}
                />
            </div>
            <Paragraph style={{fontWeight:"bold", paddingTop:"20px"}}>نکات کلیدی:</Paragraph>
            <ul>
                <li>درخواست کاربر در هر مرحله باید بررسی شود و در صورت بروز مشکل خطای مناسب برگردانده شود. برای مثال مبلغ درخواست نباید بیشتر از موجودی قابل برداشت کاربر باشد</li>
                <li>می‌توانید بین نگه داشتن دیتا در حافظه یا دیتابیس انتخابی خود، انتخاب کنید.</li>
                <li>نیازی به پیاده‌سازی احراز هویت کاربر نیست.</li>
                <li>توجه شود که در هنگام ثبت درخواست، یا درخواست با موفقیت ثبت می‌شود و مبلغ کسر می‌گردد و در صورت بروز خطا هیچ اتفاقی نمی‌افتد.</li>
                <li>صف بررسی کارمند بانک بر اساس زمان درخواست است به شکلی که در خواست‌هایی که زودتر ثبت شده‌اند در بالای لیست بررسی قرار می‌گیرند.</li>
            </ul>
        </div>
    )
}